import { render } from "./AiDropLoader.vue?vue&type=template&id=1a0df72c&scoped=true"
const script = {}

import "./AiDropLoader.scss?vue&type=style&index=0&id=1a0df72c&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a0df72c"]])

export default __exports__